<div class="dashboard-grafico__skeleton" *ngIf="loading">
  <p-skeleton height="200px" borderRadius="12px"></p-skeleton>
</div>

<ng-container *ngIf="!loading">
  <!-- Tres barras independentes: comparam, nao somam -->
  <div class="dashboard-grafico__canvas" *ngIf="temGrafico" role="img" [attr.aria-label]="ariaLabel">
    <p-chart type="bar" [data]="chartData" [options]="chartOptions" height="200px"></p-chart>
  </div>

  <!-- O backend preenche os tres tipos com zero; se ainda assim vier vazio, texto neutro -->
  <p class="dashboard-grafico__fallback" *ngIf="!temGrafico">
    {{ texts.vazio }}
  </p>

  <!-- Equivalente textual do grafico, para leitor de tela -->
  <table class="dashboard-grafico__resumo" *ngIf="temGrafico">
    <caption>{{ texts.titulo }}</caption>
    <tbody>
      <tr *ngFor="let item of dados">
        <th scope="row">{{ rotuloDoTipo(item.tipo) }}</th>
        <td>{{ item.quantidade }}</td>
      </tr>
      <tr>
        <th scope="row">{{ texts.total_movimentacoes }}</th>
        <td>{{ totalMovimentacoes }}</td>
      </tr>
    </tbody>
  </table>
</ng-container>
